// extracted by mini-css-extract-plugin
module.exports = {"AccountNavigation":"styles_AccountNavigation__X_sch","links":"styles_links___mdPw","link":"styles_link__Bszh3"};